import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Row, Col } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { H3, Breadcrumbs, H4, Btn } from '../../../AbstractElements';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { Add, BinAccount, deactivationStb, reactivationStb, disconnectionStb, Search, Filter, Status, applyPackage, Exportoexcel, ExportoPdf, Actions, Applypackage, reconnectionStb, Area, BinAccountList } from '../../../Constant';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { deleteStb, getProvider, getProviderRole, viewStb, viewStbRole, getstatscountStb, getstatscountStbRole, deleteStbRole, getArea, getAreaRole, getCustomers, getCustomersRole } from '../../../CommonUrl';
import { useSelector } from 'react-redux';
import Popup from '../../Common/Popup/popup';
import DeactivateModal from './DeactivateModal';
import Disconnectmodal from './Disconnectmodal';
import ReactivateModal from './ReactiveModal';
import ApplyPackModal from './ApplyPackModal'
import { conditionalRowStyles } from '../../Common/Rowstyle/Rowstyle';
import Transparentspinner from '../../Common/Loader/Transparentspinner';
import HandleApiError from '../../Common/ErrorImport/ErrorImport';
import { toast } from 'react-toastify';
import ReconnectModal from './ReconnectModal';
import WidgetSmall from '../../Common/Progress/WidgetSmall';
import { useForm } from 'react-hook-form';
import CustomerFilter from '../../Common/CustomerFilter/CustomerFilter';

const StbListContainer = () => {
    const [spinnerTrans, setspinnerTrans] = useState(false);
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const sortedBy = params.get("sortBy");
    const sortedOrder = params.get("sortOrder");
    const searchKey = params.get('search') || '';
    const start_date = params.get('start_date') || '';
    const end_date = params.get('end_date') || '';
    const providerId = params.get('provider') || '';
    const connectionId = params.get('connection') || '';
    const custFilter = params.get('customer') || '';
    const areaFilter = params.get('area') || '';
    const status = params.get('status') || '';

    const { register, setValue, handleSubmit, } = useForm({
        defaultValues: {
            search: searchKey,
            customer: custFilter,
            area: areaFilter,
            provider: providerId,
            connection: connectionId,
            status: status,
        },
    });

    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const [stbLists, setStbList] = useState([]);
    const [provider, setProvider] = useState([]);
    const [filters, setFilters] = useState({
        search: searchKey,
        start: start_date,
        end: end_date,
        provider: providerId,
        custFilter: custFilter,
        connection: connectionId,
        areaFilter: areaFilter,
        status: status
    });
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [selectedRows, setselectedRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [isCustomer, setIsCustomer] = useState('');
    const [modaldeactivate, setmodalDeactivate] = useState(false);
    const [modalreactivate, setmodalReactivate] = useState(false);
    const [modalDisconnect, setModalDisconnect] = useState(false);
    const [modalReconnect, setModalReconnect] = useState(false);
    const [modalPackage, setModalPackage] = useState(false);
    const [deactivateValue, setDeactivateValue] = useState({})
    const [reactivateValue, setReactivateValue] = useState({})
    const [disconnectValue, setdisconnectValue] = useState({})
    const [reconnectValue, setReconnectValue] = useState({})
    const [packageValue, setpackageValue] = useState({})
    const [staticwidgets, setstaticwidgets] = useState([])
    const [apiArea, setapiArea] = useState([]);
    const [apiCustomer, setapiCustomer] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const [toggledClearRows, setToggleClearRows] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: sortedBy, order: sortedOrder });
    const [currentCustomer, setCurrentCustomer] = useState()


    useEffect(() => {
        if (filters.areaFilter) {
            const selectedArea = apiArea.find((area) => area.id === parseInt(filters.areaFilter));
            if (selectedArea) {
                setValue('area', selectedArea.id.toString());
            }
        }
    }, [filters.areaFilter, apiArea, setValue]);

    useEffect(() => {
        if (filters.custFilter) {
            const selectedCustomer = apiCustomer.find((customer) => customer.id === parseInt(filters.custFilter));
            if (selectedCustomer) {
                setValue('customer', selectedCustomer.id.toString());
            }
        }
    }, [filters.custFilter, apiCustomer, setValue]);

    useEffect(() => {
        if (filters.status) {
            const selectedStatus = staticwidgets.find((status) => status.id === parseInt(filters.status));
            if (selectedStatus) {
                setValue('status', selectedStatus.id.toString());
            }
        }
    }, [filters.status, staticwidgets, setValue]);


    useEffect(() => {
        setValue('search', filters.search);
    }, [setValue, filters.search]);

    const dectivateStbTitle = <span className='billerqColor bolder '>
        <h3>{deactivationStb}</h3>
    </span>

    const rectivateStbTitle = <span className='billerqColor bolder '>
        <h3>{reactivationStb}</h3>
    </span>

    const disconnectStbTitle = <span className='billerqColor bolder '>
        <h3>{disconnectionStb}</h3>
    </span>

    const reconnectStbTitle = <span className='billerqColor bolder '>
        <h3>{reconnectionStb}</h3>
    </span>

    const packageStbTitle = <span className='billerqColor bolder '>
        <h3>{applyPackage}</h3>
    </span>

    useEffect(() => {
        fetchStb(1);
        getwidgetsdata();
        providerData();
        areaData();
        customerData();
    }, [])


    const statusOptions = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
        { value: "suspended", label: "Suspended" },
        { value: "disconnected", label: "Disconnected" }
    ];

    const StbColumns = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.Si,
            width: '70px',
        },
        {
            name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
            selector: row => row.action,
            cell: row => <ActionCell row={row} />,
            center: true,
            width: '70px',
        },
        {
            name: <H4>Bin Account No</H4>,
            id: 'stb_no',
            selector: row => row.Sub,
            sortable: true,
            wrap: true,
            width: '190px',
        },
        {
            name: <H4>Name</H4>,
            id: 'customer_name',
            selector: row =>
                (authState.userRole === 1 || authState.permissions.includes("show-customer-profile")) ?
                    <Link style={{ fontWeight: '500' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.customer_id}`}>
                        {row.Name}
                    </Link> : row.Name,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Area</H4>,
            id: 'area_name',
            selector: row => row.StbType,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Service Address</H4>,
            id: 'customer_name',
            selector: row => row.Address,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Driver</H4>,
            id: 'driver_name',
            selector: row => row.StbMake,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Status</H4>,
            selector: row => row.Status,
            width: '100px',
            cell: row => (
                <div>
                    <span
                        className={`badge badge-${row.Status}`}
                    >
                        {row.Status}
                    </span>
                    {row.Status === 'disconnected' && (
                        <span>{row.StatusDate}</span>
                    )}
                </div>
            ),
        },

    ];

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortedBy === column.id) {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/customers/bin?search=${filters.search}&start_date=${filters.start}&end_date=${filters.end}&provider=${filters.provider}&connection=${filters.connection}&customer=${filters.custFilter}&area=${filters.areaFilter}&status=${filters.status}&sortBy=${column.id}&sortOrder=${newOrder}`);
        } else {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/customers/bin?search=${filters.search}&start_date=${filters.start}&end_date=${filters.end}&provider=${filters.provider}&connection=${filters.connection}&customer=${filters.custFilter}&area=${filters.areaFilter}&status=${filters.status}&sortBy=${column.id}&sortOrder=${newOrder}`);
        }
    };

    const customerData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCustomers : getCustomersRole);
        if (data.status === true) {
            setapiCustomer(data.data);
        } else {
            HandleApiError(data.status);
        }
    };

    const areaData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getArea : getAreaRole);
        if (data.status === true) {
            setapiArea(data.data);
        } else {
            HandleApiError(data.status);
        }
    };

    const getwidgetsdata = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getstatscountStb : getstatscountStbRole);
        if (data.status === true) {
            setstaticwidgets(data.data);
        } else {
            HandleApiError(response.status)
        }
    }

    const ActionCell = ({ row }) => {
        const [dropdownOpen, setDropdownOpen] = React.useState(false);
        const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

        const handleEditClick = () => {
            const editFormURL = `${process.env.PUBLIC_URL}${process.env.PUBLIC_URL}/customers/bin-edit?id=${row.id}`;
            navigate(editFormURL);
        };

        const deleteStbList = () => {
            SweetAlert.fire({
                title: 'Confirm deletion?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'cancel',
                reverseButtons: true
            }).then(async (result) => {
                setspinnerTrans(true)
                if (result.value) {
                    const deleteRes = { stb_id: row.id }
                    const customerDelete = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? deleteStb : deleteStbRole, deleteRes);
                    if (customerDelete.status === 200) {
                        if (customerDelete.data.message === "success") {
                            SweetAlert.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            );
                        } else {
                            toast.error(customerDelete.data.message);
                        }
                        fetchStb(currentPage, perPage, filters.search, filters.start, filters.end, filters.provider, filters.connection, filters.status, sortConfig.column, sortConfig.order);
                    } else {
                        HandleApiError(response.status)
                    }
                }
                setspinnerTrans(false)
            });
        };

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ fontSize: '14px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                    {row.Status !== "suspended" && row.Status !== "disconnected" && (authState.userRole === 1 || authState.permissions.includes('stb-deactivate')) && (
                        <DropdownItem style={toggleStyle} onClick={() => handleModalDeactivate(row)}>Deactivate</DropdownItem>
                    )}
                    {row.Status !== "active" && row.Status !== "disconnected" && (authState.userRole === 1 || authState.permissions.includes('stb-activate')) && (
                        <DropdownItem style={toggleStyle} onClick={() => handleModalReactivate(row)}>Activate</DropdownItem>
                    )}
                    {row.Status !== "disconnected" && (authState.userRole === 1 || authState.permissions.includes('stb-disconnect')) && (
                        <DropdownItem style={toggleStyle} onClick={() => handleModalDisconnect(row)}>Disconnect</DropdownItem>
                    )}
                    {row.Status === "disconnected" && (authState.userRole === 1 || authState.permissions.includes('stb-disconnect')) && (
                        <DropdownItem style={toggleStyle} onClick={() => handleModalReconnect(row)}>Reconnect</DropdownItem>
                    )}
                    {row.Status === "active" && (authState.userRole === 1 || authState.permissions.includes('apply-package')) && (
                        <DropdownItem style={toggleStyle} onClick={() => handleModalPackage(row)}>Apply Package</DropdownItem>
                    )}
                    {(authState.userRole === 1 || authState.permissions.includes('edit-stb')) && (
                        <DropdownItem style={toggleStyle} onClick={() => handleEditClick()}>Edit</DropdownItem>
                    )}
                    {row.DeleteStatus === 1 && (authState.userRole === 1 || authState.permissions.includes('remove-stb')) &&
                        <DropdownItem style={{ padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px' }} onClick={() => deleteStbList()}>Delete</DropdownItem>
                    }
                </DropdownMenu>
            </Dropdown>
        );
    };

    const handleModalDeactivate = (e) => {
        setDeactivateValue(e);
        setmodalDeactivate(!modaldeactivate);
    }
    const handleModalReactivate = (e) => {
        setReactivateValue(e);
        setmodalReactivate(!modalreactivate);
    }

    const handleModalDisconnect = (e) => {
        setdisconnectValue(e);
        setModalDisconnect(!modalDisconnect);
    }

    const handleModalReconnect = (e) => {
        setReconnectValue(e);
        setModalReconnect(!modalReconnect);
    }

    const handleSelectable = (selected) => {
        const selectedRow = selected.selectedRows.map((items) => items);
        setselectedRows(selectedRow);
    }

    const handleModalPackage = (e) => {
        setpackageValue(e);
        setModalPackage(!modalPackage);
    }

    const handleBundlePackage = () => {
        if (selectedRows.length > 0) {
            setpackageValue(selectedRows)
            setModalPackage(!modalPackage);
        } else {
            toast.error("Please select subscribers")
        }
    }

    const handleChange = (selectedOption) => {
        setIsCustomer(selectedOption);
        setCurrentCustomer(selectedOption)
    };

    const providerData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getProvider : getProviderRole);
        if (data.status === true) {
            setProvider(data.data);
        } else {
            HandleApiError(response.status)
        }
    };

    const fetchStb = async (page, size = perPage) => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewStb +
            `?page=${page}&page_length=${size}&search=${filters.search}&start_date=${filters.start}&end_date=${filters.end}&provider_id=${filters.provider}&connection_type=${filters.connection}&area_id=${filters.areaFilter}&customer_id=${filters.custFilter}&status=${filters.status}&sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}` :
            viewStbRole + `?page=${page}&page_length=${size}&search=${filters.search}&start_date=${filters.start}&end_date=${filters.end}&provider_id=${filters.provider}&connection_type=${filters.connection}&area_id=${filters.areaFilter}&customer_id=${filters.custFilter}&status=${filters.status}&sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`);
        const responce_api = response.data.data;
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const SerialNo = (page - 1) * size + 1;
            setStbList(responce_api.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    Sub: <span>{e.stb_no}</span>,
                    Name: e.customer_name,
                    Serial: e.serial_no,
                    StbNo: e.stb_no,
                    Date: e.activated_at,
                    ConnectType: e.connection_type,
                    StbType: e.area_name,
                    StbMake: e.driver_name,
                    Address: e.service_address,
                    Status: e.stb_status,
                    id: e.id,
                    customer_id: e.customer_id,
                    DeleteStatus: e.stb_delete,
                    StatusDate: e.status_date
                }
            }))
            setTotalRows(response.data.total);
        } else {
            HandleApiError(response.status)
        }
        setspinnerTrans(false)
    };

    const handlePageChange = page => {
        fetchStb(page, perPage, filters.search, filters.start, filters.end, filters.provider, filters.connection, filters.custFilter, filters.areaFilter, filters.status, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchStb(page, newPerPage, filters.search, filters.start, filters.end, filters.provider, filters.connection, filters.custFilter, filters.areaFilter, filters.status, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };

    const exportStbExcel = async () => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            viewStb + `?export=stb_data&search=${filters.search}&start_date=${filters.start}&end_date=${filters.end}
            &provider_id=${filters.provider}&connection_type=${filters.connection}&area_id=${filters.areaFilter}&customer_id=${filters.custFilter}&status=${filters.status}
            &sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`
            : viewStbRole + `?export=stb_data&search=${filters.search}&start_date=${filters.start}&end_date=${filters.end}
            &provider_id=${filters.provider}&connection_type=${filters.connection}&area_id=${filters.areaFilter}&customer_id=${filters.custFilter}&status=${filters.status}
            &sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`);
        const dataToExport = response.data.map(({ stb_no, customer_name, driver_name, area_name, service_address, stb_status, }) => ({ Bin_No: stb_no, customer_name, driver_name, area_name, service_address, Bin_Status: stb_status }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Bin Data');
            XLSX.writeFile(wb, 'bin_data.xlsx');
        } else {
            HandleApiError(response.status)
        }
        setspinnerTrans(false)
    };

    const exportStbPdf = async () => {
        setspinnerTrans(true)

        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            viewStb + `?export=stb_data&search=${filters.search}&start_date=${filters.start}&end_date=${filters.end}
            &provider_id=${filters.provider}&connection_type=${filters.connection}&area_id=${filters.areaFilter}&customer_id=${filters.custFilter}&status=${filters.status}
            &sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`
            : viewStbRole + `?export=stb_data&search=${filters.search}&start_date=${filters.start}&end_date=${filters.end}
            &provider_id=${filters.provider}&connection_type=${filters.connection}&area_id=${filters.areaFilter}&customer_id=${filters.custFilter}&status=${filters.status}
            &sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`);
        const dataToExport = response.data.map(({ stb_no, customer_name, driver_name, area_name, service_address, stb_status, }, index) =>
            ({ index: index + 1, stb_no, customer_name, driver_name, area_name, service_address, stb_status, })); if (response.status === true) {
                const doc = new jsPDF();
                const columns = ["#", "Bin Account No", "Name", "Driver", "Area", 'Service Address', "Status",];
                const rows = dataToExport.map(({ index, stb_no, customer_name, driver_name, area_name, service_address, stb_status, }) =>
                    [index, stb_no, customer_name, driver_name, area_name, service_address, stb_status,]
                );
                doc.autoTable({
                    head: [columns],
                    body: rows
                });
                doc.save("Bin-Data.pdf");
            } else {
            HandleApiError(response.status)
        }
        setspinnerTrans(false)
    };

    const onSubmit = async (data) => {
        // e.preventDefault()
        // setToggleClearRows(true);
        const search = data.search || '';
        const status = data.status;
        const custFilter = isCustomer?.value || '';
        const areaFilter = data.area || '';
        const queryParams = new URLSearchParams({
            search: search,
            area: areaFilter,
            customer: custFilter,
            status: status,
            sortBy: sortConfig.column || '',
            sortOrder: sortConfig.order || '',
        }).toString();
        navigate(`/customers/bin?${queryParams}`);
        setFilters({
            search,
            custFilter,
            areaFilter,
            status
        });
        fetchStb(1, perPage, search, custFilter, areaFilter, status);
    };

    return (
        <Fragment>
            {spinnerTrans && <Transparentspinner />}
            <Breadcrumbs mainTitle={BinAccount} parent="Customers" title={BinAccount} />
            <WidgetSmall details={staticwidgets} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{BinAccountList}</H3>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex' }}>
                            <CardBody className="dropdown-basic" style={{ borderRadius: '5px' }}>
                                {(authState.userRole === 1 || authState.permissions.includes('store-stb')) &&
                                    <Link to={`${process.env.PUBLIC_URL}/customers/bin-add`} className="btn btn-primary me-2" style={{ marginLeft: '10px' }}>{Add}</Link>
                                }
                                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} >
                                    <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary button-stbspace">
                                        <i className="fa fa-gear me-1"></i>{Actions}
                                    </DropdownToggle>
                                    <DropdownMenu container="body">
                                        <DropdownItem style={toggleStyle} onClick={() => exportStbExcel()}><i className="fa fa-file-excel-o me-2"></i>{Exportoexcel}</DropdownItem>
                                        <DropdownItem style={toggleStyle} onClick={() => exportStbPdf()}><i className="fa fa-file-pdf-o me-2"></i>{ExportoPdf}</DropdownItem>
                                        {(authState.userRole === 1 || authState.permissions.includes("bulk-update-package")) && (
                                            <DropdownItem style={toggleStyle} onClick={() => handleBundlePackage()}><i className="fa fa-plus-circle me-2"></i>{Applypackage}</DropdownItem>)}
                                    </DropdownMenu>
                                </Dropdown>
                            </CardBody>
                        </div>

                    </div>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="ps-3 gap-sm-3 gap-md-2 mb-4 filterGap">
                            <Col sm="12" md='5' lg='2' className="form-element">
                                <input className="form-control" placeholder={Search} type="text"
                                    {...register('search')} />
                            </Col>
                            <Col sm="12" md="5" lg='2' className="form-element">
                                <CustomerFilter
                                    authState={authState}
                                    onCustomerChange={handleChange}
                                    handleApiError={HandleApiError}
                                    selectedCustomer={custFilter}
                                    currentCustomer={currentCustomer}
                                    setCurrentCustomer={setCurrentCustomer}
                                />
                            </Col>
                            <Col sm="12" md="5" lg='2' className="form-element">
                                <select className="form-select" {...register('area')}>
                                    <option value="">{Area}</option>
                                    {apiArea.map((values, index) => (
                                        <option key={index} value={values.id}>{values.name}</option>
                                    ))}
                                </select>
                            </Col>
                            <Col sm="12" md="5" lg='2' className="form-element">
                                <select className="form-select" {...register('status')}>
                                    <option value="">{Status}</option>
                                    {statusOptions.map((option, index) => (
                                        <option key={index} value={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </Col>
                            <Col sm="12" md="5" lg='1' className="custom-filtrs">
                                <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                            </Col>
                        </Row>
                    </Form>

                    <div className="order-history table-responsive">
                        <DataTable
                            columns={StbColumns}
                            data={stbLists}
                            onSort={handleSort}
                            sortServer
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            conditionalRowStyles={conditionalRowStyles}
                            onChangePage={handlePageChange}
                            fixedHeader
                            selectableRows={authState.userRole === 1 || authState.permissions.includes("bulk-update-package")}
                            onSelectedRowsChange={handleSelectable}
                            clearSelectedRows={toggledClearRows}

                        />
                    </div>
                </CardBody>
            </Card>
            <Popup isOpen={modaldeactivate} title={dectivateStbTitle} toggler={handleModalDeactivate}>
                <DeactivateModal
                    deactivateValue={deactivateValue}
                    stbLists={fetchStb}
                    handleModalDeactivate={handleModalDeactivate}
                    currentPageNo={currentPage}
                    perPagelist={perPage}
                />
            </Popup>
            <Popup isOpen={modalreactivate} title={rectivateStbTitle} toggler={handleModalReactivate}>
                <ReactivateModal
                    reactivateValue={reactivateValue}
                    stbLists={fetchStb}
                    handleModalReactivate={handleModalReactivate}
                    currentPageNo={currentPage}
                    perPagelist={perPage}
                />
            </Popup>

            <Popup isOpen={modalDisconnect} title={disconnectStbTitle} toggler={handleModalDisconnect}>
                <Disconnectmodal
                    disconnectValue={disconnectValue}
                    stbLists={fetchStb}
                    handleModalDisconnect={handleModalDisconnect}
                    currentPageNo={currentPage}
                    perPagelist={perPage}
                />
            </Popup>

            <Popup isOpen={modalReconnect} title={reconnectStbTitle} toggler={handleModalReconnect}>
                <ReconnectModal
                    reconnectValue={reconnectValue}
                    stbLists={fetchStb}
                    handleModalReconnect={handleModalReconnect}
                    currentPageNo={currentPage}
                    perPagelist={perPage}
                />
            </Popup>

            <Popup isOpen={modalPackage} title={packageStbTitle} toggler={handleModalPackage} size="xl">
                <ApplyPackModal
                    packageValue={packageValue}
                    onClose={handleModalPackage}
                    clearselectedRows={setToggleClearRows}
                />
            </Popup>


        </Fragment>
    );
};

export default StbListContainer;